<template>
    <table class="v-table table" :class="{'headless-table': hideHeader}" v-if="list.length">
        <thead v-if="!hideHeader">
            <tr>
                <th v-for="column of columns" :key="column.key" v-c:sortable="column.sortable" @click="setOrderBy(column)" class="v-table-head">
                    <slot :name="`column-${column.key}`" :column="column">
                        {{ column.label }}
                    </slot>
                    <template v-if="column.sortable">
                        <template v-if="column.key === orderBy || column.sortable === orderBy">
                            <icon name="chevron-up" v-if="orderDirection == 'asc'"/>
                            <icon name="chevron-down" v-else/>
                        </template>
                        <template v-else>
                            <icon name="unfold-more-horizontal"/>
                        </template>
                    </template>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) of list" :key="index" @click="$emit('clickItem', item)" v-c:clickable="itemsClickable">
                <td v-for="column of columns" :key="column.key">
                    <slot :name="`item-${column.key}`" :column="column"  :item="item">
                        {{ get(item, column.key) }}
                    </slot>
                </td>
            </tr>
        </tbody>
    </table>
    <div v-else class="v-table-empty-text">
        {{ emptyText || __('ui/vtable_no_data') }}
    </div>
</template>

<style lang="scss">
    .v-table {
        .v-table-empty-text {
            text-align: center;
        }
        .headless-table > tbody > tr:first-of-type > td {
            border-top: 0;
        }
        .v-table-head {
            white-space: nowrap;
        }
    }
</style>

<script>
    import get from 'lodash/get';

    export default {
        props: {
            columns: Array,
            list: Array,
            orderBy: String,
            orderDirection: String,
            itemsClickable: {type: Boolean, default: false},
            emptyText: {type: String, default: null},
            hideHeader: {type: Boolean, default: false},
        },

        methods: {
            get,
            setOrderBy(column) {
                if (!column.sortable) {
                    return;
                }
                let orderBy = column.sortable === true ? column.key : column.sortable;
                let orderDirection;

                if (orderBy === this.orderBy) {
                    orderDirection = this.orderDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    orderDirection = 'asc';
                }
                this.$emit('order', {orderBy, orderDirection});
            },
        },
    };
</script>